/**
 * Builds the PostHog identity from the `trackingInformation` endpoint response.
 *
 * Allowlist approach: only the properties listed here are sent. Direct identifiers stay out on
 * purpose (decision DO-13470): `userEmail`, `ownerEmail`, `userGlobalId` (Buhl-Konto) and
 * `ownerGlobalId` are NOT forwarded, even though Pendo receives them.
 */

export interface TrackingInformation {
  userId: number | string
  tenantId: number | string
  role?: string
  ownerUserId?: number | string
  isDesktopTenant?: boolean
  isDesktopLogin?: boolean
  createdAt?: string
  registrationClient?: string
  onboardingFinished?: boolean
  onboardingFinishedAt?: string | null
  abTest?: string | null
  [key: string]: unknown
}

export interface PostHogIdentity {
  distinctId: string
  properties: Record<string, unknown>
}

const isSubscriptionKey = (key: string) => key.includes('subscriptionEnd') || key.includes('planId')

export const buildPostHogIdentity = (trackingData: TrackingInformation, idPrefix: string): PostHogIdentity => {
  const subscriptionProps = Object.keys(trackingData)
    .filter(isSubscriptionKey)
    .reduce<Record<string, unknown>>((result, key) => {
      result[key] = trackingData[key]
      return result
    }, {})

  return {
    distinctId: `${idPrefix}${trackingData.userId}`,
    properties: {
      product: ENV.product,
      role: trackingData.role,
      tenantId: `${idPrefix}${trackingData.tenantId}`,
      ownerUserId: trackingData.ownerUserId,
      isDesktopTenant: trackingData.isDesktopTenant,
      isDesktopLogin: trackingData.isDesktopLogin,
      tenantCreatedAt: trackingData.createdAt,
      registrationClient: trackingData.registrationClient,
      ...subscriptionProps,
      onboardingFinished: trackingData.onboardingFinished,
      onboardingFinishedAt: trackingData.onboardingFinishedAt,
      abtest: trackingData.abTest,
    },
  }
}
